import { MethodologySectionComponent } from "./components/methodology-section/methodology-section.component";
import { SessionFormComponent } from "./components/session-form/session-form.component";
import {
  PlanningSessionsCtrl,
  CloneSessionsCtrl,
  PlanningSessionConflictsCtrl,
  SessionSelectorCtrl,
  DemoSessionCtrl,
  InspectAssigneessWorkflowCtrl,
  InspectGoalsWorkflowCtrl,
  InspectStatisticsCtrl,
  InspectWorkflowCtrl,
  NudgePeopleCtrl,
  PlanningSessionOverviewCtrl,
  PlanningSessionService,
  PlanningSessionsActions,
  PlanningSessionSelector,
  SessionFormCtrl,
  DeleteSessionConfirmationService,
  SessionsGanttChart,
} from ".";
import {
  ApprovalWorkflowSelectionFormComponent,
  ApprovalWorkflowSelectionModal,
} from "./components/approval-workflow-selection-form/approval-workflow-selection-form.component";
import { WorkflowSelectionAccordionComponent } from "./components/workflow-selection-accordion/workflow-selection-accordion.component";

const mod = angular
  .module("sessions", [])
  .controller("PlanningSessionsCtrl", PlanningSessionsCtrl)
  .controller("CloneSessionsCtrl", CloneSessionsCtrl)
  .controller("PlanningSessionConflictsCtrl", PlanningSessionConflictsCtrl)
  .controller("SessionSelectorCtrl", SessionSelectorCtrl)
  .controller("DemoSessionCtrl", DemoSessionCtrl)
  .controller("InspectAssigneessWorkflowCtrl", InspectAssigneessWorkflowCtrl)
  .controller("InspectGoalsWorkflowCtrl", InspectGoalsWorkflowCtrl)
  .controller("InspectStatisticsCtrl", InspectStatisticsCtrl)
  .controller("InspectWorkflowCtrl", InspectWorkflowCtrl)
  .controller("NudgePeopleCtrl", NudgePeopleCtrl)
  .controller("PlanningSessionOverviewCtrl", PlanningSessionOverviewCtrl)
  .component("approvalWorkflowSelectionForm", ApprovalWorkflowSelectionFormComponent)
  .component("workflowSelectionAccordion", WorkflowSelectionAccordionComponent)
  .service("PlanningSessionService", PlanningSessionService)
  .service("PlanningSessionsActions", PlanningSessionsActions)
  .service("PlanningSessionSelector", PlanningSessionSelector)
  .service("DeleteSessionConfirmationService", DeleteSessionConfirmationService)
  .service("ApprovalWorkflowSelectionModal", ApprovalWorkflowSelectionModal)

  .directive("sessionsGanttChart", SessionsGanttChart.factory())

  .component("sessionForm", SessionFormComponent)
  // since we use the component in the state factory we need to register the controllers separately
  .controller("SessionFormCtrl", SessionFormCtrl)
  .component("methodologySection", MethodologySectionComponent);

export default mod.name;
